import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

export class TempoTraining extends Component { // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    this.state = {
      pyramid: ["", "", "", ""],
      checked: false
    }
  }
  componentDidMount() {
    const { tempo } = this.props;
    const { pyramid } = this.state;
    if (tempo) {
      let splits = tempo.split(',');
      let newPyramid = pyramid;
      splits.map((split, i) => {
        newPyramid[i] = split;
        return null;
      })
      this.setState({
        pyramid: newPyramid,
        checked: true
      })
    }

  }
  handlePyramid = setIndex => e => {
    let newPyramid = this.state.pyramid;
    const { value } = e.target;
    if (/[^0-9]/g.test(value)) {
      newPyramid[setIndex] = newPyramid[setIndex];
    } else {
      newPyramid[setIndex] = value;
    }
    this.setState({
      pyramid: newPyramid
    }, () => {
      let string = newPyramid.toString();
      if (string === ',,,') {
        this.props.changeField('')
      } else {
        this.props.changeField(string);
      }
    });
  }

  toggleTempo = (event) => {
    const { checked } = event.target;
    if (!checked) {
      this.setState({ pyramid: ["", "", "", ""] }, () => this.props.changeField(''));
    }
    this.setState({ checked });
  }

  render() {
    const { pyramid, checked } = this.state;
    const labels = ['Down', 'Hold', 'Up', 'Hold'];
    return (
      <div className="additionalOptionItem">
        <div style={{ width: '5%', marginLeft: 15, display: 'flex', alignItems: 'center' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={this.toggleTempo}
              />
            }
          />
        </div>
        <div style={{ width: '95%' }}>
          {
            checked ? (
              <div style={{
                display: 'flex',
                height: '100%',
                alignItems: 'center'
              }}>

                <b>Tempo Training:</b>
                {
                  pyramid.map((setIndex, i) => (
                    <TextField
                      style={{ width: 65, marginBottom: 0, marginLeft: 10 }}
                      key={'tempo-' + i}
                      label={labels[i]}
                      value={pyramid[i]}
                      onChange={this.handlePyramid(i)}
                      margin="dense"
                      variant="outlined"
                      type="text"
                      inputProps={{ maxLength: 5 }}
                    />
                  ))
                }
              </div>

            ) : (
                <p>
                  <b>Tempo Training:</b>
                  <span className="italics"> Select when you want to prescribe the number of seconds to raise and lower the weight.
                </span>
                </p>
              )
          }
        </div>
      </div>
    )
  }
}


export default TempoTraining;



// WEBPACK FOOTER //
// ./src/components/workouts/inputs/TempoTraining.js